const diaBrasilia = (date) => date.toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });

/** Quantas viradas de dia (horário de Brasília) houve entre `iso` e agora. */
export function diasDeCalendario(iso) {
  const um = Date.parse(`${diaBrasilia(new Date(iso))}T00:00:00Z`);
  const hoje = Date.parse(`${diaBrasilia(new Date())}T00:00:00Z`);
  return Math.round((hoje - um) / 86400000);
}
